export type View = "home" | "logging" | "analytics" | "settings" | "milestones" | "import" | "tasks" | "about";

// Views directly restorable from a fresh page load's URL (a bookmark or refresh). "import" and
// "about" are reachable only by navigating from within the app, same as when this was hash-based.
const RESTORABLE_VIEWS: View[] = ["home", "logging", "analytics", "milestones", "settings", "tasks"];

// The authenticated dashboard (Home/Logging/Analytics/Milestones/Settings/Import/Tasks) lives
// under /mybaby/*, kept out of search indexes via a robots.txt Disallow (see public/robots.txt) —
// unlike the signed-out/onboarding screens at "/", which are the indexable marketing landing page.
const APP_PATH_PREFIX = "/mybaby";

export function parseInitialViewFromPath(pathname: string): View {
  const match = pathname.match(/^\/mybaby\/([a-z]+)/)?.[1];
  return RESTORABLE_VIEWS.includes(match as View) ? (match as View) : "home";
}

export function buildAppUrl(params: {
  authScreen: "none" | "register" | "signin";
  view: View;
  isMainAppView: boolean;
  // True while a signed-in user has no baby profile yet, i.e. the OnboardingView guard branch
  // in App.tsx. Gives that screen its own indexable/trackable URL instead of sharing "/" with
  // the loading/auth-error states, so it shows up as its own page in analytics.
  showOnboarding?: boolean;
}): string {
  if (params.authScreen !== "none") return `/#${params.authScreen}`;
  if (params.isMainAppView) return `${APP_PATH_PREFIX}/${params.view}`;
  if (params.showOnboarding) return "/get-started";
  return "/";
}
